import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import BigNumber from 'bignumber.js';
import { forkJoin } from 'rxjs';
import { LetterOfCreditStatus } from 'src/app/shared/models/letter-credit-status.enum';
import { ShoppingCartService } from 'src/app/shared/services/cart/shopping-cart.service';
import { TokensService } from 'src/app/shared/services/tokens/token.service';
import { OnkeypressService } from 'src/app/shared/services/util/onkeypress.service';
import { ValueConverterService } from 'src/app/shared/services/util/value-converter.service';
import { LetterOfCredit } from '../../shared/models/letter-of-credit.model';

@Component({
    selector: 'app-modal-request',
    templateUrl: './modal-request.component.html',
    styleUrls: ['./modal-request.component.scss', '../new/new.component.scss']
})
export class ModalRequestComponent implements OnInit {

    public title: string = 'answer';
    public letter: LetterOfCredit;
    public suggestValue: boolean;
    public tokensAmount: string = '0,00';
    public tokenPrice: BigNumber = new BigNumber(0);
    public message: string;
    public proposedValue: number = 0;

    constructor(
        private readonly dialogRef: MatDialogRef<ModalRequestComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly shoppingCartService: ShoppingCartService,
        private readonly valueConverter: ValueConverterService,
        private readonly tokenService: TokensService,
        private readonly keypressService: OnkeypressService // used in HTML
    ) { }

    public ngOnInit(): void {
        if (this.data) {
            this.title = this.data.title;
            this.letter = this.data.letter;
            this.tokenPrice = this.letter.tokenQuotation;
            this.proposedValue = new BigNumber(this.letter.valueOffered).toNumber();
            this.tokenService.getTokens().subscribe(tokens => {
                let mainToken = tokens.find(tkn => tkn.isMain);
                forkJoin([
                    this.shoppingCartService.quotations(mainToken?.id),
                ]).subscribe(async ([data]) => {
                    this.tokenPrice = new BigNumber(data.amount);
                    this.convertTokens(this.letter.valueOffered);
                });
            });
            
        }
        this.dialogRef.addPanelClass('custom-modal');
    }

    public onKeyPressEvent(event: any){
        this.keypressService.onlyAllowNumbers(event);
    }

    public blockNegativeNumber(event: any, value: number): void {
        if (value == 0) {
            event.preventDefault();
        }
    }

    public convertTokens(amountMoney: number | string | BigNumber): void {
        this.tokensAmount = this.valueConverter.convertCurrencyToTokens(this.tokenPrice, amountMoney);
    }

    public confirmOperation(): void {
        if (this.title === 'answer') {
            this.letter.valueRequested = new BigNumber(this.proposedValue);
            this.letter.currentStatus = LetterOfCreditStatus.AN;
        } else if (this.title === 'deny') {
            this.letter.currentStatus = LetterOfCreditStatus.D;
        } else if (this.title === 'approve') {
            this.letter.currentStatus = LetterOfCreditStatus.AP;
            this.letter.valueRequested = new BigNumber(this.proposedValue);
        }
        this.letter.comment = this.message;
        this.dialogRef.close({
            operation: this.title,
            letter: this.letter
        });
    }
}
